import { Injectable } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { FormPagePerformancePageService } from '@client/app/modules/page-performance/forms/page/form-page-performance-page.service';

@Injectable({
    providedIn: 'root',
})
export class FrequencyTranslationService {
    constructor (
        private formPagePerformancePageService: FormPagePerformancePageService,
        private translateService: TranslateService,
    ) {}

    getFrequencyTranslation (frequency?: number): string {
        const frequencyOptions = this.formPagePerformancePageService.getFrequencyOptions();
        const frequencyOption = frequencyOptions.find(option => option.value === frequency);

        if (frequencyOption) {
            return frequencyOption.name;
        }
        return this.translateService.getString('No Frequency');
    }
}
